application.register("part_ui_dropdown", class extends Stimulus.Controller {
    connect() {
        this._timeout = "";
    }

    toggleDropdown(e) {
        let el = e.target.closest("[aria-expanded]");

        e.preventDefault();
        e.stopPropagation();
        clearTimeout(this._timeout);

        if (el.classList.contains("state--toggled")) {
            this.closeDropdown(el);
        } else {
            this.openDrowdown(el);
        }
    }

    openDrowdown(elm) {
        elm.classList.add("state--toggled", "state--active");
        elm.setAttribute("aria-expanded","true");
        elm.nextElementSibling.removeAttribute("aria-hidden");
    }

    closeDropdown(elm) {
        elm.classList.remove("state--toggled","state--active");
        elm.nextElementSibling.setAttribute("aria-hidden","true");
        this._timeout = setTimeout(function(){
            elm.setAttribute("aria-expanded","false");
        },300);
    }

    closeAll() {
        this.closeDropdown(this.element.querySelector("[aria-expanded]"));
    }
});